<script setup>
  import { useI18n } from 'vue-i18n'

  defineProps(['actionItem'])

  const { t } = useI18n()
</script>

<template>
  <button
    :key="actionItem.label"
    class="action-item"
    :disabled="actionItem.disabled"
    type="button"
    v-bind="actionItem.attrs"
    :aria-label="t(actionItem.label)"
    @click="actionItem.onClick"
  >
    <i :class="actionItem.icon" />
    <span>
      {{ t(actionItem.label) }}
    </span>
  </button>
</template>

<style lang="scss" scoped>
  .action-item {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 10px;
    cursor: pointer;
    outline: 0;
    background: none;
    border: 0;
    color: var(--fm-ui-layout-header-action-color);
    padding: 3px 5px;
    border-radius: 3px;
    font-size: 10px;
    @include focusRing;

    &:hover:not(:disabled) {
      background: rgba(255, 255, 255, 0.1);
    }

    &:focus {
      background: rgba(255, 255, 255, 0.15);
    }

    &:disabled {
      cursor: not-allowed;
      color: light-dark(#ccc, #ccc);
    }

    i {
      font-size: 17px;
    }
  }
</style>
